import script from "./ObrasAdminDash.vue?vue&type=script&setup=true&lang=js"
export * from "./ObrasAdminDash.vue?vue&type=script&setup=true&lang=js"

import "./ObrasAdminDash.vue?vue&type=style&index=0&id=6926d0fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6926d0fd"]])

export default __exports__